import { initialPasswordManagementState } from './password-management.state';
import { createReducer, on } from '@ngrx/store';
import * as PasswordManagementActions from './password-management.actions';

export const passwordManagementReducer = createReducer(
  initialPasswordManagementState,
  on(PasswordManagementActions.resetPassword, (state) => {
    const newState = { ...state };
    delete newState.resetPasswordErrors;
    return newState;
  }),
  on(PasswordManagementActions.resetPasswordError, (state, { errors }) => ({
    ...state,
    resetPasswordErrors: errors,
  })),
);
